import { Data, DotLottieWorkerReact } from '@lottiefiles/dotlottie-react'
import cn from 'classnames'
import { FC, useEffect, useState } from 'react'

import { Text } from '@ds'

import styles from './GeneralPopupCard.module.scss'

type Props = {
  image: string
  onClick?: () => void
  isHolographic?: boolean
  isAvatar?: boolean
  title?: string
}

export const getExtension = (value: string): string | null => {
  const match = value.match(/\.([a-z0-9]+)$/i)
  return match ? match[1] : null
}

const ItemCardContentLottie = ({ imgUrl }: { imgUrl: string }) => {
  const [data, setData] = useState<Data>()

  useEffect(() => {
    fetch(imgUrl)
      .then((res) => res.arrayBuffer())
      .then((data) => setData(data))
  }, [imgUrl])

  return <DotLottieWorkerReact data={data} loop autoplay />
}

const ImageItem = (
  {image,
  isAvatar}: {
    image: string
    isAvatar: boolean
  }
) => {
  const extension = getExtension(image)
  if (extension === 'lottie') {
    return <ItemCardContentLottie imgUrl={image} />
  }

  if (extension === 'mp4') {
    return (
      <div className={styles.videoWrapper}>
        <video
          src={image}
          autoPlay
          loop
          className={cn(styles.image, {
            [styles.maskAvatar]: isAvatar,
          })}
        />
      </div>
    )
  }

  return (
    <img
      src={image}
      className={cn(styles.image, {
        [styles.maskAvatar]: isAvatar,
      })}
    />
  )
}
export const GeneralPopupCard: FC<Props> = ({
  title,
  image,
  onClick,
  isHolographic = false,
  isAvatar = false,
}) => {
  return (
    <div
      className={cn(styles.card, {
        [styles.holographic]: isHolographic,
      })}
      onClick={onClick}
    >
      <ImageItem image={image} isAvatar={isAvatar} />
      {title && (
        <Text type="h1" className={styles.title}>
          {title}
        </Text>
      )}
    </div>
  )
}
